/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tduzggWPyptPHtemkm2DXC

import { createUseStyleTokens } from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: tduzggWPyptPHtemkm2DXC/projectModule

const data = {
  base: `${"plasmic_tokens_tduzggWPyptPHtemkm2DXC"} ${"plasmic_tokens_5ZtnypMovRHeeP3YTdPCYL"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"}`,
  varianted: [
    {
      className: "global_themeOrange_override",
      groupName: "themeOrange",
      variant: "override"
    },
    {
      className: "global_themePurpleDark_override",
      groupName: "themePurpleDark",
      variant: "override"
    }
  ]
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
